module.exports = __webpack_public_path__ + "img/vipBg1.87d9e707.png";